import { getSectionItemComponent } from "./emailSectionItemComponent";

const proccessAttachments = (attachments) => {
  const proccessedAttachments = [];

  for (let i = 0; i < attachments.length; i += 3) {
    proccessedAttachments.push(attachments.slice(i, i + 3));
  }

  return proccessedAttachments;
};

export const getEmailAttachmentComponent = (fileName, url) =>
  `
            <td
            style="
                font-size: 0px;
                word-break: break-word;
            "
            >
            <div
                class="mj-column-per-100 mj-outlook-group-fix"
                style="
                font-size: 0;
                line-height: 0;
                text-align: left;
                display: inline-block;
                width: 100%;
                direction: ltr;
                "
            >
                <!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td style="vertical-align:top;width:35px;" ><![endif]-->
                <div
                class="mj-column-px-50 mj-outlook-group-fix"
                style="
                    font-size: 0px;
                    text-align: left;
                    direction: ltr;
                    display: inline-block;
                    vertical-align: top;
                    width: 35px !important;
                "
                >
                <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    role="presentation"
                    style="
                    vertical-align: top;
                    "
                    width="100%"
                >
                    <tbody>
                    <tr>
                        <td
                        align="center"
                        style="
                            font-size: 0px;
                            padding: 0px;
                            padding-top: 8px;
                            padding-bottom: 8px;
                            word-break: break-word;
                        "
                        >
                        <table
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style="
                            border-collapse: collapse;
                            border-spacing: 0px;
                            "
                        >
                            <tbody>
                            <tr>
                                <td
                                style="
                                    width: 20px;
                                "
                                >
                                <img
                                    height="auto"
                                    src="{{ATTACHMENTS_ICON}}"
                                    style="
                                    border: 0;
                                    display: block;
                                    outline: none;
                                    text-decoration: none;
                                    height: auto;
                                    width: 100%;
                                    font-size: 13px;
                                    "
                                    width="20"
                                />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
                <!--[if mso | IE]></td><td style="vertical-align:top;width:202px;" ><![endif]-->
                <div
                class="mj-column-per-70 mj-outlook-group-fix"
                style="
                    font-size: 0px;
                    text-align: left;
                    direction: ltr;
                    display: inline-block;
                    vertical-align: top;
                    width: 70%;
                "
                >
                <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    role="presentation"
                    style="
                    vertical-align: top;
                    "
                    width="100%"
                >
                    <tbody>
                    <tr>
                        <td
                        align="left"
                        style="
                            font-size: 0px;
                            padding: 10px 25px;
                            padding-top: 12px;
                            padding-right: 0;
                            padding-left: 0;
                            word-break: break-word;
                        "
                        >
                        <a
                            href="${url}"
                            target="_blank" 
                            rel="noopener noreferrer"
                            style="
                            font-family: Roboto, Arial;
                            font-size: 12px;
                            line-height: 1;
                            text-align: left;
                            "
                        >
                            ${fileName}
                        </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
            </div>
            </td>
`;

export const getEmailAttachmentSectionComponent = (attachments) => `
            <tr>
                <td
                style="
                    font-size: 0px;
                    padding: 20px 0;
                    padding-top: 0;
                    padding-right: 4px;
                    padding-bottom: 0;
                    padding-left: 4px;
                    word-break: break-word;
                "
                >
                <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:598px;" width="598" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                <div
                    style="margin: 0px auto; max-width: 598px"
                >
                    <table
                    align="center"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    role="presentation"
                    style="width: 100%"
                    >
                    <tbody>
                        ${proccessAttachments(attachments)
                          .map(
                            (chunk) =>
                              `
                            <tr>
                              ${chunk
                                .map(({ fileName, url }) =>
                                  getSectionItemComponent({
                                    width: "185px",
                                    marginBottom: "4px",
                                    content: getEmailAttachmentComponent(
                                      fileName,
                                      url
                                    ),
                                  })
                                )
                                .join("")}
                            </tr>
                          `
                          )
                          .join("")}
                    </tbody>
                    </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
                </td>
            </tr>
`;
